// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Store$LiveRoom from "../Store.bs.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as AnimateHeight$LiveRoom from "../bindings/AnimateHeight.bs.js";
import * as SterlingIcons$LiveRoom from "../bindings/SterlingIcons.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

function notificationToMessage(t, t2, message) {
  if (typeof message !== "object") {
    if (message === "EnrollFailed") {
      return Curry._1(t, "Notification_enrollFailed");
    } else {
      return Curry._1(t, "Notification_bidIsTooLow");
    }
  }
  if (message.NAME === "PlaceBidError") {
    return Curry._1(t, "Notification_placeBidError").concat(Belt_Option.mapWithDefault(message.VAL, "", (function (detail) {
                      return ": " + detail + "";
                    })));
  }
  var match = message.VAL;
  return Curry._2(t2, "Notification_outbid", {
              lotNr: match[0],
              lotTitle: match[1]
            });
}

var initialState = {
  notifications: /* [] */0
};

var StoreConfig = {
  initialState: initialState
};

var InternalStore = Store$LiveRoom.MakeStore(StoreConfig);

function register(name, cb) {
  Curry._2(InternalStore.register, name, cb);
}

function unregister(name) {
  Curry._1(InternalStore.unregister, name);
}

var Store = {
  StoreConfig: StoreConfig,
  initialState: initialState,
  InternalStore: InternalStore,
  register: register,
  unregister: unregister
};

var messageStyle = Curry._1(Css.style, {
      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
      tl: {
        hd: Css.marginLeft("auto"),
        tl: {
          hd: Css.marginRight("auto"),
          tl: {
            hd: Css.maxWidth({
                  NAME: "subtract",
                  VAL: [
                    Css.pct(100.0),
                    Css.px(88)
                  ]
                }),
            tl: /* [] */0
          }
        }
      }
    });

function container(color) {
  return Curry._1(Css.style, {
              hd: Css.position("relative"),
              tl: {
                hd: Css.width(Css.pct(100.0)),
                tl: {
                  hd: Css.textAlign("center"),
                  tl: {
                    hd: Css.paddingLeft(Css.px(5)),
                    tl: {
                      hd: Css.paddingRight(Css.px(10)),
                      tl: {
                        hd: Css.paddingTop(Css.px(8)),
                        tl: {
                          hd: Css.paddingBottom(Css.px(8)),
                          tl: {
                            hd: Css.backgroundColor(color),
                            tl: {
                              hd: Css.fontWeight({
                                    NAME: "num",
                                    VAL: StyleConstants$LiveRoom.regular
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

var closeWrapper = Curry._1(Css.style, {
      hd: Css.position("absolute"),
      tl: {
        hd: Css.right(Css.px(24)),
        tl: {
          hd: Css.top(Css.pct(50.0)),
          tl: {
            hd: Css.transform({
                  NAME: "translateY",
                  VAL: Css.pct(-50.0)
                }),
            tl: /* [] */0
          }
        }
      }
    });

function clearTimer(timerId) {
  var id = timerId.current;
  if (id !== undefined) {
    clearTimeout(Caml_option.valFromOption(id));
    return ;
  }
  
}

function setTimerForVisibilityChange(timerId, setVisibility) {
  timerId.current = Caml_option.some(setTimeout((function (param) {
              Curry._1(setVisibility, (function (param) {
                      return "hidden";
                    }));
            }), 10000));
}

function Notification$Bar(props) {
  var onCloseClicked = props.onCloseClicked;
  var onLeaveAnimationEnd = props.onLeaveAnimationEnd;
  var notification = props.notification;
  var match = React.useState(function () {
        return "visible";
      });
  var setVisibility = match[1];
  var visibility = match[0];
  var timerId = React.useRef(undefined);
  var match$1 = I18next$LiveRoom.useTranslation(undefined);
  React.useEffect((function () {
          setTimerForVisibilityChange(timerId, setVisibility);
          return (function (param) {
                    clearTimer(timerId);
                  });
        }), []);
  var lotRouteElement = notification.navigate;
  return React.createElement(AnimateHeight$LiveRoom.make, {
              visibility: visibility,
              duration: StyleConstants$LiveRoom.animationFastInt,
              onHeightAnimationEnd: (function (param) {
                  if (visibility === "visible") {
                    return ;
                  } else {
                    return Curry._1(onLeaveAnimationEnd, notification.key);
                  }
                }),
              children: React.createElement("div", {
                    className: container(notification.color),
                    onMouseEnter: (function (param) {
                        clearTimer(timerId);
                      }),
                    onMouseLeave: (function (param) {
                        setTimerForVisibilityChange(timerId, setVisibility);
                      })
                  }, lotRouteElement !== undefined ? Caml_option.valFromOption(lotRouteElement) : React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                          className: messageStyle,
                          children: notificationToMessage(match$1.t, match$1.t2, notification.message)
                        }), React.createElement("div", {
                        className: closeWrapper
                      }, React.createElement(Button.Button, {
                            onClick: (function (param) {
                                clearTimer(timerId);
                                Curry._1(onCloseClicked, notification.key);
                              }),
                            className: Curry._1(Css.style, {
                                  hd: Css.important(Css.borderStyle(Css.none)),
                                  tl: /* [] */0
                                }),
                            buttonStyle: "secondary",
                            size: "regularIcon",
                            children: React.createElement(SterlingIcons$LiveRoom.Collection.CloseRegular24.make, {
                                  className: Curry._1(Css.style, {
                                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                                        tl: /* [] */0
                                      })
                                })
                          })))
            });
}

var Bar = {
  container: container,
  closeWrapper: closeWrapper,
  clearTimer: clearTimer,
  notificationTimeout: 10000,
  setTimerForVisibilityChange: setTimerForVisibilityChange,
  make: Notification$Bar
};

function generateRandomKey(param) {
  return Math.random().toString() + Math.random().toString();
}

function addNotification(message, color, navigate) {
  var newNotification_key = generateRandomKey(undefined);
  var newNotification = {
    key: newNotification_key,
    message: message,
    color: color,
    navigate: navigate
  };
  var newList_1 = Curry._1(InternalStore.getState, undefined).notifications;
  var newList = {
    hd: newNotification,
    tl: newList_1
  };
  if (Belt_List.length(newList) < 5) {
    return Curry._1(InternalStore.update, {
                notifications: newList
              });
  }
  var dropLast = Belt_List.keepWithIndex(newList, (function (_n, i) {
          return i < 4;
        }));
  Curry._1(InternalStore.update, {
        notifications: dropLast
      });
}

function removeNotification(id) {
  Curry._1(InternalStore.update, {
        notifications: Belt_List.keep(Curry._1(InternalStore.getState, undefined).notifications, (function (n) {
                return n.key !== id;
              }))
      });
}

function showWarning(message, navigateOpt, param) {
  var navigate = navigateOpt !== undefined ? Caml_option.valFromOption(navigateOpt) : undefined;
  addNotification(message, {
        NAME: "hex",
        VAL: SterlingTokens$LiveRoom.Colors.alertOrange60_nohashtag
      }, navigate);
}

function showError(message) {
  addNotification(message, {
        NAME: "hex",
        VAL: SterlingTokens$LiveRoom.Colors.alertRed60_nohashtag
      }, undefined);
}

var container$1 = Curry._1(Css.style, {
      hd: Css.position("fixed"),
      tl: {
        hd: Css.top(Css.px(0)),
        tl: {
          hd: Css.left(Css.px(0)),
          tl: {
            hd: Css.right(Css.px(0)),
            tl: {
              hd: Css.zIndex(StyleConstants$LiveRoom.notificationZIndex),
              tl: /* [] */0
            }
          }
        }
      }
    });

function $$Notification(props) {
  var match = React.useState(function () {
        return /* [] */0;
      });
  var setNotifications = match[1];
  React.useEffect((function () {
          Curry._2(InternalStore.register, "Notification-LiveRoom", (function (s) {
                  Curry._1(setNotifications, (function (param) {
                          return s.notifications;
                        }));
                }));
          return (function (param) {
                    Curry._1(InternalStore.unregister, "Notification-LiveRoom");
                  });
        }), []);
  return React.createElement(PropSpread$LiveRoom.make, {
              aria: {
                hd: {
                  TAG: /* Live */5,
                  _0: "polite"
                },
                tl: /* [] */0
              },
              children: React.createElement("div", {
                    className: container$1
                  }, Belt_List.toArray(Belt_List.map(match[0], (function (notification) {
                              return JsxPPXReactSupport.createElementWithKey(notification.key, Notification$Bar, {
                                          notification: notification,
                                          onLeaveAnimationEnd: removeNotification,
                                          onCloseClicked: removeNotification
                                        });
                            }))))
            });
}

var make = $$Notification;

export {
  notificationToMessage ,
  Store ,
  messageStyle ,
  Bar ,
  generateRandomKey ,
  addNotification ,
  removeNotification ,
  showWarning ,
  showError ,
  container$1 as container,
  make ,
}
/* InternalStore Not a pure module */
